module.exports = __webpack_public_path__ + "static/10-4121d36ab2fb6c14d007145969e4e663.png";